"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _en = {};

var _en2 = _interopRequireDefault(_en);

var _fr = {};

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkflowMessages = {
    'en': _en2.default,
    'fr': _fr2.default
};

exports.default = WorkflowMessages;